module.exports = __webpack_public_path__ + "assets/img/0616ef534c3ab851dd24d0643bb68b2d.png";